import { render, staticRenderFns } from "./encasement.vue?vue&type=template&id=3fc757cc&scoped=true&"
import script from "./encasement.vue?vue&type=script&lang=js&"
export * from "./encasement.vue?vue&type=script&lang=js&"
import style0 from "./encasement.vue?vue&type=style&index=0&id=3fc757cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc757cc",
  null
  
)

export default component.exports